import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import EntityButton from '../../../components/Common/Buttons/EntityButton';
import {EntityClasses} from '../../../constants/EntityTypes';
import {Search} from './Search';
import {DirectActivation, ActivationsList} from './DirectActivations/DirectActivation';
import {TopMenu} from './Menus/TopMenu';
import {PopupTopHeaderPanel, PopupHeaderFirstSection} from './PopupHeaderPanel';
import {PrintLabelButtonWithTooltip} from '../../../components/Common/FormLabel/components/QuickPrintButton';
import {showActionsSuggestions} from '../../../features/Personalization/actions';
import {executeActivation} from '../actions/directActivations';

import {
    SingleLineHeaderPanel,
    PrivTreeHeaderPanel,
    ReconLineHeaderPanel,
    QuickSearchTopHeaderPanel,
    ButtonWithTooltip
} from './UniqueScreensHeader';
import {ReconSubformHeader} from './ReconSubformHeader';
import {LowerMenu} from './Menus/LowerMenu';
import {
    Button,
    PriorityIcon,
    Dropdown,
    ButtonTrigger,
    Flex,
    Icon
} from '@priority-software/priority-style-react';
import {formsStore} from '../../Form/stores/FormsStore';
import {formsStore as newApiFormsStore} from '../../../stores/Form/FormsStore';
import SavingStatus from './SaveStatus/SaveStatus';
import {ClearSearchButton} from './ClearSearchButton';
import {QuickSearch} from '../../QuickSearch/components/QuickSearch';
import {renderGeneratorNewState} from '../../Searches/renderGenerator';
import {showEntityHelpMessage} from '../../../_shared/Help/actions/helpActions';
import {MoreInfo} from '../../../features/MoreInfo';
import {Tooltip} from '../../../components/Common/Tooltip';

@observer
class HeaderPanel extends Component<any, any> {
    renderChooseBox = () => {
        const {funcs, isOptionArrow = true} = this.props;
        if (isOptionArrow && funcs.isParentForm && funcs.isParentForm()) {
            return (
                <div className="choose-box-container">
                    <Button
                        skin="secondary"
                        onClick={funcs.chooseOption}
                        size="small"
                        disabled={false}
                    >
                        {getLocalizedText(texts.chooseValue)}
                    </Button>
                </div>
            );
        }

        return null;
    };

    renderMoreActs() {
        const {funcs, directActivations} = this.props;
        const moreActs = directActivations.slice(2);
        if (moreActs.length > 0) {
            return (
                <Dropdown
                    trigger={
                        <Tooltip
                            tooltip={getLocalizedText(texts.actionTooltip)}
                            className="actions-tooltip"
                        >
                            <ButtonTrigger skin="secondary">
                                <Flex componentClasses="actionsTriggerBtnWrapper">
                                    {getLocalizedText(texts.dirActs)}
                                    <Icon
                                        icon={PriorityIcon.iconMore}
                                        iconColor="primary-500"
                                        style={{fontSize: '20px'}}
                                    />
                                </Flex>
                            </ButtonTrigger>
                        </Tooltip>
                    }
                    onOpen={() =>
                        showActionsSuggestions(formsStore.currentFormName, directActivations)
                    }
                    onClose={funcs.focus}
                    className="direct-activations"
                    openingSide="leftSide"
                >
                    <Dropdown.Content width={300}>
                        <Dropdown.Header
                            title={getLocalizedText(texts.dirActs)}
                            componentClasses="actions-menu-header"
                        />
                        {moreActs.length > 7 ? (
                            <Search
                                options={moreActs}
                                inputProps={{
                                    placeholder: getLocalizedText(texts.searchActPlaceholder),
                                    autoFocus: true,
                                    componentClasses: 'more-acts-search',
                                    size: 'large'
                                }}
                                listProps={{
                                    renderItem: DirectActivation,
                                    autoHeightMax: 358,
                                    autoHeight: true
                                }}
                                onSelect={this.props.onOptionSelect}
                                keyToSearch={'title'}
                                renderList={ActivationsList}
                            />
                        ) : (
                            <ActivationsList
                                data={moreActs}
                                onOptionSelect={this.props.onOptionSelect}
                                maxHeight={430}
                            />
                        )}
                    </Dropdown.Content>
                </Dropdown>
            );
        } else {
            return null;
        }
    }

    /** setUpdateTopIconsFunc is needed for GWT updates - when rerendering is needed at the GWT side. See `withUpdate` documentation.*/
    renderPageMenu = (extraMarkup?, searchButton?) => {
        const {searchesStore, currentForm} = formsStore;
        const {topMenu, funcs, isRTL, isReconView} = this.props;
        const {setUpdateTopIconsFunc} = funcs;
        return (
            <TopMenu
                key={currentForm?.session}
                topMenu={topMenu}
                setUpdateFunc={setUpdateTopIconsFunc}
                funcs={funcs}
                isRTL={isRTL}
                extraMarkup={extraMarkup}
                searchButton={searchButton}
                searchesStore={searchesStore}
                currentForm={currentForm}
                selectedSearch={searchesStore && searchesStore.formSelected}
                isReconView={isReconView?.()}
            />
        );
    };
    /** setUpdateLowIconsFunc is needed for GWT updates - when rerendering is needed at the GWT side. See `withUpdate` documentation. */
    renderLowerMenu = () => {
        const {lowerMenu, topMenu, isPopupView, funcs, isRTL} = this.props;
        const {setUpdateLowIconsFunc} = funcs;
        return (
            <LowerMenu
                lowerMenu={lowerMenu}
                topMenu={topMenu}
                setUpdateFunc={setUpdateLowIconsFunc}
                funcs={funcs}
                isPopupView={isPopupView}
                isRTL={isRTL}
            />
        );
    };

    renderUpperSection() {
        const {
            breadCrumbs,
            funcs,
            procEntity,
            isPopupView,
            topMenu,
            isSingleRowHeader,
            isPrivTreeView,
            isRTL,
            lowerMenu,
            isReconView,
            isReconSubformHeader,
            isQuickSearch,
            reactFormSession
        } = this.props;
        const {currentForm, searchesStore} = formsStore;

        if (formsStore.isReactView) {
            return (
                <ReconLineHeaderPanel
                    renderPageMenu={this.renderPageMenu}
                    breadCrumbs={breadCrumbs}
                    lowerMenu={lowerMenu}
                    isRTL={isRTL}
                />
            );
        }

        if (isReconSubformHeader) {
            return (
                <ReconSubformHeader
                    topMenu={topMenu}
                    breadCrumbs={breadCrumbs}
                    lowerMenu={lowerMenu}
                    isRTL={isRTL}
                    funcs={funcs}
                    currentForm={currentForm}
                />
            );
        }

        if (isReconView && isReconView()) {
            return (
                <ReconLineHeaderPanel
                    renderPageMenu={this.renderPageMenu}
                    breadCrumbs={breadCrumbs}
                    lowerMenu={lowerMenu}
                    isRTL={isRTL}
                />
            );
        }

        if (isPopupView && isPopupView()) {
            return isQuickSearch && isQuickSearch() ? (
                <QuickSearchTopHeaderPanel isRTL={isRTL} topMenu={topMenu} />
            ) : (
                <PopupTopHeaderPanel isRTL={isRTL} topMenu={topMenu} />
            );
        }

        if (isSingleRowHeader) {
            const {setUpdateTopIconsFunc} = funcs;

            return (
                <SingleLineHeaderPanel
                    setUpdateFunc={setUpdateTopIconsFunc}
                    renderChooseBox={this.renderChooseBox}
                    breadCrumbs={breadCrumbs}
                    isRTL={isRTL}
                    topMenu={topMenu}
                    procEntity={procEntity}
                    searchesStore={searchesStore}
                    currentForm={currentForm}
                />
            );
        }
        if (isPrivTreeView)
            return (
                <PrivTreeHeaderPanel
                    breadCrumbs={breadCrumbs}
                    isRTL={isRTL}
                    topMenu={topMenu}
                    procEntity={procEntity}
                />
            );
        return (
            <section className="upper-section">
                <section className="breadcrumbs-choose">
                    <BreadCrumbs
                        breadCrumbs={breadCrumbs}
                        reactBreadCrumbs={
                            reactFormSession
                                ? newApiFormsStore.getScreenBySession(reactFormSession).breadcrumbs
                                : []
                        }
                        formName={currentForm?.name}
                        formSession={currentForm?.session}
                        {...procEntity}
                    />
                    {this.renderChooseBox()}
                    <SavingStatus status={formsStore.savingStatus} />
                </section>
                {this.renderPageMenu()}
            </section>
        );
    }

    renderLowerSection() {
        const {
            directActivations,
            isSingleRowHeader,
            isPrivTreeView,
            isPopupView,
            isReconSubformHeader
        } = this.props;
        const visibleActs = directActivations.slice(0, 2);

        if (isSingleRowHeader || isPrivTreeView || formsStore.isReactView || isReconSubformHeader) {
            return null;
        }

        return (
            <section className="lower-section">
                {this.renderFirstSectionButtons()}

                <section className="second-section">
                    <section className="activations-section">
                        {visibleActs.map((act, index) => {
                            return (
                                <EntityButton
                                    key={index}
                                    onClick={event => {
                                        executeActivation(event, act);
                                    }}
                                    onContextMenu={e => showEntityHelpMessage(act.exec, e.target)}
                                    text={act.title}
                                    entityType={act.type}
                                    style={EntityClasses[act.type]}
                                />
                            );
                        })}
                        {this.renderMoreActs()}
                    </section>
                    {isPopupView?.() && formsStore?.currentForm?.showPrintLabels && (
                        <PrintLabelButtonWithTooltip
                            isPopup
                            skin="standart"
                            tooltip={getLocalizedText(texts.quickPrintTooltip)}
                        />
                    )}
                    {this.renderLowerMenu()}
                </section>
            </section>
        );
    }

    renderFirstSectionButtons() {
        const {isPopupView, createNewRow, getIsQueryForm} = this.props;
        const {currentForm} = formsStore;

        if (isPopupView && isPopupView()) {
            return (
                <section className="first-section">
                    <PopupHeaderFirstSection {...this.props} />
                    <SavingStatus status={formsStore.savingStatus} />
                </section>
            );
        }

        return (
            <section className="first-section">
                {!formsStore?.currentForm?.isStatusForm() &&
                    getIsQueryForm &&
                    !getIsQueryForm() && (
                        <Button prefixIcon={PriorityIcon.addSmall} onClick={createNewRow}>
                            {getLocalizedText(texts.newTxt)}
                        </Button>
                    )}
                <div className="group-buttons">
                    {currentForm && currentForm.isQuickSearch ? (
                        <QuickSearch
                            quickSearchStore={currentForm && currentForm.quickSearchStore}
                        />
                    ) : (
                        <ButtonWithTooltip
                            tooltip={getLocalizedText(texts.searchTooltip)}
                            skin="secondary"
                            prefixIcon={PriorityIcon.filter}
                            onClick={renderGeneratorNewState}
                        >
                            {getLocalizedText(texts.advancedSearch)}
                        </ButtonWithTooltip>
                    )}
                    <ClearSearchButton formsStore={formsStore}>
                        {getLocalizedText(texts.clearForm)}
                    </ClearSearchButton>
                </div>
            </section>
        );
    }

    render() {
        const {getDocName} = this.props;
        const docName: string = getDocName && getDocName();
        return (
            <header className="header-panel">
                <MoreInfo docName={docName} />
                {this.renderUpperSection()}
                {this.renderLowerSection()}
                <div id="searchesGenerator" />
            </header>
        );
    }
}

export default HeaderPanel;
